export const daysOptions = [
  { label: 'Segunda-feira', value: 'mon' },
  { label: 'Terça-feira', value: 'tue' },
  { label: 'Quarta-feira', value: 'wed' },
  { label: 'Quinta-feira', value: 'thu' },
  { label: 'Sexta-feira', value: 'fri' },
  { label: 'Sábado', value: 'sat' },
  { label: 'Domingo', value: 'sun' },
];
